<template>
  <bean-source-page :type="type" :columns="columns" :form-columns="formColumns" :filter-columns="filterColumns"
    :actions="[]" :form="form" :title="$t('model.orderSnapshot')" :onFetchData="onFetchData"
    resource="order_snapshots" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, formColumnsExtend } from '../admin_grapes/order_snapshots.js';
import { columnsExtend } from '@/views/order_snapshot/columns_extend.js';

@Component
export default class OrderSnapshots extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  async onFetchData({ type, resource }) {
    const that = this

    if (type === 'index') {
      const orderSnapshots = (await this.$request.post('/mine/generate_order_snapshots'))
      const { data, pagination } = await this.$request.get(`/${resource}`, { params: { ...this.$route.query } });

      if (orderSnapshots.length !== 0) {
        const message = {
          functional: true,
          render() {
            return (
              <bean-table value={orderSnapshots} columns={columnsExtend([
                {
                  key: 'order',
                  renderCell: (h, { props: { value } }) => {
                    const click = () => {
                      that.$request.put('/order_snapshots/read', { params: { order_id: value.id } })

                      that.$router.push({ name: 'orders.show', params: { id: value.id } })
                    }
                    return (
                      <div onClick={click}>
                        <a href="javascript:;">{value.number}</a>
                      </div>
                    )
                  }
                },
                'changes_product_image',
                'changes_content'
              ])} />
            )
          }
        }

        this.$msgbox({
          title: '订单修改提醒',
          message: this.$createElement(message),
          showCancelButton: false,
          confirmButtonText: '关闭'
        });
      }

      return {
        data,
        pagination
      }
    }

    if (type === 'show') {
      const data = await this.$request.get(`/${resource}/${this.$route.params.id}`);

      return { data };
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'readed_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'order',
        renderCell: (h, { props: { value } }) => {
          const click = () => {
            this.$request.put('/order_snapshots/read', { params: { order_id: value.id } })

            this.$router.push({ name: 'orders.show', params: { id: value.id } })
          }
          return (
            <div onClick={click}>
              <a href="javascript:;">{value.number}</a>
            </div>
          )
        }
      },
      'changes_product_image',
      'changes_content',
      {
        key: 'created_at',
        label: '提醒信息生成时间'
      },
      'readed',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'order_snapshots.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'order_snapshots.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/order_snapshots',
    name: 'order_snapshots.index',
    component: OrderSnapshots,
    props: {
      type: 'index',
    }
  },
  {
    path: '/order_snapshots/new',
    name: 'order_snapshots.new',
    component: OrderSnapshots,
    props: {
      type: 'new',
    }
  },
  {
    path: '/order_snapshots/:id',
    name: 'order_snapshots.show',
    component: OrderSnapshots,
    props: {
      type: 'show',
    }
  },
  {
    path: '/order_snapshots/:id/edit',
    name: 'order_snapshots.edit',
    component: OrderSnapshots,
    props: {
      type: 'edit'
    }
  }
]
</script>
